@for (date of dates; track $index; let i = $index) {
  <div
    class="w-full relative flex flex-col"
    [style.left.px]="-1 * i"
    [style.width]="dayViewColumnWidth"
  >
    <div class="week-view-column cursor-pointer" (click)="onSwitchToDayView(date)">
      <div class="week-view-column-header">
        <span class="calendar-day">{{ date | date: 'E' }}</span>
        <span
          class="calendar-date"
          [class.selected]="isSelected(date)"
          [class.today]="isToday(date)"
        >
          {{ date.getDate() }}
        </span>
      </div>
    </div>

    <blaze-calendar-day-view
      class="snap-end relative"
      [blazeTimeTrack]="true"
      [selectedDate]="date"
      [events]="extractEventsFromCalendars(date)"
      [defaultDurationMinutes]="defaultDurationMinutes"
      [timeFormat]="timeFormat"
      [isAddEnabled]="isAddEnabled"
      [isEditEnabled]="isEditEnabled"
      [isDeleteEnabled]="isDeleteEnabled"
      [isDetailsViewEnabled]="isDetailsViewEnabled"
      [isEventDragDisabled]="isEventDragDisabled"
      [scrollAllDayToHour]="{ idx: i, count: dates.length }"
      [timeScale]="timeScale"
      [availableHours]="availableHours"
      [eventFontSize]="eventFontSize"
      [headerHeightPx]="headerHeightPx"
      (add)="add.emit($event)"
      (details)="details.emit($event)"
      (edit)="edit.emit($event)"
      (delete)="delete.emit($event)"
      (eventChange)="eventChange.emit($event)"
      (eventDrop)="eventDrop.emit($event)"
    />
  </div>
}
